import styled from 'styled-components';
import { colours, fonts } from '../../styles/theme';

type LabelStyledProps = {
  readonly theme?: string
}

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const LabelStyled = styled.label<LabelStyledProps>`
  width: ${({ theme }) => (theme === 'secondary' ? 'auto' : '170px')};
  display: inline-block;
  text-transform: capitalize;
  ${({ theme }) => {
    switch (theme) {
      case 'secondary':
        return fonts.font1.H13;
      default:
        return fonts.font1.H13B;
    }
  }}
`;

export const PostLabelStyled = styled.label`
  display: inline-block;
  ${fonts.font1.H13}
`;

export const ErrorWrapper = styled.div`
  margin-bottom: 0.35rem;
  margin-top: 0.35rem;
  color: ${colours.colour18};
  ${fonts.font1.H14B}
`;
